<nz-select
  #select
  nzShowSearch
  nzAllowClear
  [nzPlaceHolder]="placeholder"
  [nzLoading]="loading$ | async"
  [nzServerSearch]="isServerSideSearch"
  (nzOnSearch)="onSearch($event)"
>
  <nz-option
    *ngFor="let entity of entities$ | async; trackBy: trackByRef"
    [nzLabel]="entity | emApplyPure: getName : nameKey : getNameFunction"
    [nzValue]="entity | emApplyPure: getValue : valueKey"
  ></nz-option>
</nz-select>
